import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "lg:hidden border-b-2 border-gray-stroke pb-4 pt-2 mx-8 mb-4 font-bold text-lg" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "absolute top-4 right-8 lg:static lg:flex lg:items-center lg:justify-center" }

import { TheTable, TableTh, TableTd, TableTr, TableTHead, TableTBody } from '@/components/table'
import { ITableData, ERowTypes } from '@/types/interfaces/table'


export default /*#__PURE__*/_defineComponent({
  props: {
    data: { type: null, required: true },
    horizontalOnMobile: { type: Boolean, required: false },
    cellClassOnMobile: { type: String, required: false }
  },
  setup(__props: any) {

const props = __props as {
    data: ITableData
    horizontalOnMobile?: boolean
    cellClassOnMobile?: string
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TheTable), null, {
    default: _withCtx(() => [
      _createVNode(_unref(TableTHead), null, {
        default: _withCtx(() => [
          _createVNode(_unref(TableTr), null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data.head, (item, idx) => {
                return (_openBlock(), _createBlock(_unref(TableTh), {
                  key: item,
                  class: _normalizeClass(["py-4 px-8 text-left", {
                        'text-center': _ctx.$slots['row-actions'] && idx === props.data.head.length - 1,
                    }])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(TableTBody), null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data.body, (row, rowId) => {
            return (_openBlock(), _createBlock(_unref(TableTr), {
              id: parseInt(rowId.toString()),
              key: `row-${rowId.toString()}`,
              class: "relative bg-primary",
              "custom-class": props.cellClassOnMobile
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _renderSlot(_ctx.$slots, "row-title", {
                    row: row,
                    index: rowId
                  }, () => [
                    _createTextVNode(_toDisplayString(row[0]), 1)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, cellId) => {
                  return (_openBlock(), _createBlock(_unref(TableTd), {
                    key: `cell-${cellId.toString()}`
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass([
                            props.horizontalOnMobile
                                ? 'grid grid-rows-2 lg:grid-rows-1'
                                : 'grid grid-cols-2 lg:grid-cols-1',
                        ])
                      }, [
                        _createElementVNode("strong", {
                          class: _normalizeClass(["lg:hidden", {
                                'uppercase text-primary text-xs block mb-2':
                                    props.horizontalOnMobile,
                            }])
                        }, _toDisplayString(props.data.head[parseInt(cellId.toString())]), 3),
                        (cell.type === _unref(ERowTypes).COMPONENT)
                          ? (_openBlock(), _createBlock(_resolveDynamicComponent(cell.component), _normalizeProps(_mergeProps({ key: 0 }, cell.componentConfig)), null, 16))
                          : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(cell), 1))
                      ], 2)
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                (_ctx.$slots['row-actions'])
                  ? (_openBlock(), _createBlock(_unref(TableTd), { key: 0 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _renderSlot(_ctx.$slots, "row-actions", { row: row })
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["id", "custom-class"]))
          }), 128))
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})